/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { useEffect } from "react";
import { Const } from "const";
import { useMapDataContext } from "context/MapDataProvider";
import { useInterval } from "react-use";
import { useGetMapData } from "./GetMapDataHook";

export const useMapDataWorker = () => {
  const { setMapData, setMapVer } = useMapDataContext();
  const { loading, value, retry, error } = useGetMapData();

  useEffect(() => {
    if (!loading && value) {
      setMapData(value?.mapInfo);
      setMapVer(value?.mapVer);
    }
  }, [loading, value, setMapData, setMapVer]);

  useInterval(() => {
    if (!loading) {
      retry();
    }
  }, Const.mapCheckInterval);
  return { loading, value, retry, error };
};
